const ConstantColors = {
  o: {
    black: '#26091C',
    dark: '#380E73',
    purple: '#8C15BF',
    light: '#B21DF2',
    blue: '#4B1DF2',
    red: '#F21D1D',
    white: '#FFFFFF',
  },
  i: {
    gray: '#B2C1D2',
    darkgray: '#8494A7',
    lightblue: '#ACD1FC',
    grayblue: '#4D647D',
    darkblue: '#253A52',
    dBlue: '#0F2033'
  }
};

export default ConstantColors;
